/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer_repliesComment = {
    readonly id: string;
    readonly enteredLive: boolean | null;
    readonly replyCount: number;
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_comment" | "IgnoredTombstoneOrHideContainer_comment">;
    readonly " $refType": "ReplyListContainer_repliesComment";
};
export type ReplyListContainer_repliesComment$data = ReplyListContainer_repliesComment;
export type ReplyListContainer_repliesComment$key = {
    readonly " $data"?: ReplyListContainer_repliesComment$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer_repliesComment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer_repliesComment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "replyCount",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_comment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_comment"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enteredLive",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = 'd361fa0cc4eb186b1a748787acba39ad';
export default node;
